import { connect } from "react-redux";
import { Creators } from "../../../reducer";
import AddIssue from "./AddIssue";

export default connect(null, dispatch => ({
  onSave: (text, customerKey) => dispatch(Creators.saveIssue(text, customerKey))
}))(AddIssue);



// WEBPACK FOOTER //
// ./src/customer/components/EditCustomer/AddIssue/index.js